module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAMAAAC6V+0/AAAAAXNSR0IArs4c6QAAAGNQTFRFAAAA////////////19fX1tbW1tbW1tbW1NTU09PT09PT0tLS0dHR0tLS0tLS0tLS09PT0dHR0dHR0tLS0dHR0dHR0dHR0dHR0tLS0tLS0tLS0dHR0tLS0dHR0dHR0tLS0dHRLR3HRwAAACB0Uk5TAAIEBRMZJSxNUVJVb3F2d4qhoqW+zs/Z3N3z9Pn6+/3pmSZDAAAApklEQVQY022R2xKDIAxEo4hK0WKLLYq3/P9X2gQsTu0+Zc6QZLMAkIS2zntntYCv1IBRg4oo6/CkLmPIbDZSmpkp9/KDO5WGy88EEeZJgjLMFaDxF6IGGwqT2tGCC0VahOjA40U+wWlKkNvXhyoAittzDe206FUdB1dvXkSWyhRDyZbIfJtgy+bpzK05WLPxmSGQvs4B8ro/AonRLeO4nKL7G/L1O3ZNyBw5mjY/YwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/user.png
// module id = TlOy
// module chunks = 1